module.exports = __webpack_public_path__ + "static/img/OneAgency2.b2943d14.png";